import axios from 'axios'
import { enqueueSnackbar } from 'notistack';
// const Baseurl = "http://localhost:5001"
const Baseurl = "https://api.imoxkitchen.com"
const getProduct = async (searchterm,page) => {
    try{
      const params = new URLSearchParams();
      if (searchterm) { 
         params.append('q', searchterm); 
      }
       params.append('inAct', true);
       params.append('page',page)
       params.append('limit',10)
       let data = await axios(`${Baseurl}/products?${params.toString()}`,{withCredentials:true})
       return data
    }catch(error){
       console.log(error);
    }
}

const dealProductList = async () => {
   try{
   
      let data = await axios(`${Baseurl}/products?deal=true`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const addProduct = async (params) => {
    try{
       let data = await axios.post(`${Baseurl}/products`,params,{withCredentials:true})
       return data
    }catch(error){
       console.log(error);
    }
}

const deleteProduct = async (id) => {
   try{
      let data = await axios.delete(`${Baseurl}/products/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
      alert(`${error?.response?.data?.message}, Failed`)
   }
}

const getCategory = async () => {
    try{
       let data = await axios(`${Baseurl}/category`,{withCredentials:true})
       return data
    }catch(error){
       console.log(error);
    }
}

const createCategory = async (params) => {
   try{
      let data = await axios.post(`${Baseurl}/category`,params,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const deleteCategory = async (id) => {
   try{
      let data = await axios.delete(`${Baseurl}/category/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const getCategoryByID = async (id) => {
   try{
      let data = await axios(`${Baseurl}/category/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 } 

 const getCategById = async (id) => {
   try{
      let data = await axios(`${Baseurl}/categ/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 } 

const getBrand = async (searchterm,page) => {
    try{
      const params = new URLSearchParams();
      if (searchterm) { 
         params.append('q', searchterm); 
      }
       params.append('page',page)
       params.append('limit',10)
       let data = await axios(`${Baseurl}/brand?admin=true&${params.toString()}`,{withCredentials:true})
       return data
    }catch(error){
       console.log(error);
    }
}

const getBrandForProdEdit = async () => {
    try{
       let data = await axios(`${Baseurl}/brand`,{withCredentials:true})
       return data
    }catch(error){
       console.log(error);
    }
}

const getAuthor = async () => {
   try{
      let data = await axios(`${Baseurl}/author`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const addBrand = async (params) => {
   try{
      let data = await axios.post(`${Baseurl}/brand`,params,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const addAuthor = async (params) => {
   try{
      let data = await axios.post(`${Baseurl}/author`,params,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const deleteBrand = async (id) => {
  try{
     let data = await axios.delete(`${Baseurl}/brand/${id}`,{withCredentials:true})
     return data
  }catch(error){
     console.log(error);
  }
} 

const deleteAuthor = async (id) => {
   try{
      let data = await axios.delete(`${Baseurl}/author/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 } 

const getBrandByID = async (id) => {
   try{
      let data = await axios(`${Baseurl}/brand/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 } 

 const getAuthorByID = async (id) => {
   try{
      let data = await axios(`${Baseurl}/author/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 } 

 const updateBrandByID = async (id,params) => {
   try{
      let data = await axios.patch(`${Baseurl}/brand/${id}?times=${new Date().getTime()}`,params,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 }  

 const updateCategoryData = async (id,params) => {
   try{
      let data = await axios.patch(`${Baseurl}/category/${id}?times=${new Date().getTime()}`,params,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 }

 const updateAuthorData = async (id,params) => {
   try{
      let data = await axios.patch(`${Baseurl}/author/${id}?times=${new Date().getTime()}`,params,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
 }


const getType = async () => {
   try{
      let data = await axios(`${Baseurl}/type`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const addType = async (params) => {
  try{
     let data = await axios.post(`${Baseurl}/type`,params,{withCredentials:true})
     return data
  }catch(error){
     console.log(error);
  }
}

const deleteType = async (id) => {
 try{
    let data = await axios.delete(`${Baseurl}/type/${id}`,{withCredentials:true})
    return data
 }catch(error){
    console.log(error);
 }
}

const getOrders = async () => {
   try{
      let data = await axios(`${Baseurl}/orders`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
} 

const getallusers = async () => {
   try{
      let data = await axios(`${Baseurl}/getallusers`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}

const deleteUser = async (id) => {
   try{
      let data = await axios.delete(`${Baseurl}/getallusers/${id}`,{withCredentials:true})
      return data
   }catch(error){
      console.log(error);
   }
}
   const addBlog = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/blog`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
         enqueueSnackbar(`${error.response.data.failed}`, {variant:'error'});
      }
   }

   const getBlogs = async () => {
      try{
         let data = await axios(`${Baseurl}/blog`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
   }

   const getBlogById = async (id) => {
      try{
         let data = await axios(`${Baseurl}/blog/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
   }

   const editBlog = async (id,params) => {
      try{
         let data = await axios.patch(`${Baseurl}/blog/${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
   }

     const deleteBlog = async (id) => {
      try{
         let data = await axios.delete(`${Baseurl}/blog/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
   }

   const updateOrderData = async (id,params) => {
      try{
         let data = await axios.patch(`${Baseurl}/orderedproductdetails/${id}?times=${new Date().getTime()}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const orderDetails = async (id) => {
      try{
         let data = await axios(`${Baseurl}/orderedproductdetails/${id}?times=${new Date().getTime()}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const createbaner = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/banner?times=${new Date().getTime()}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const getBaner = async () => {
      try{
         let data = await axios(`${Baseurl}/banner`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const getSingleBaner = async (id) => {
      try{
         let data = await axios(`${Baseurl}/banner/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const updateBaner = async (id,params) => {
      try{
         let data = await axios.patch(`${Baseurl}/banner/${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const deleteBaner = async (id) => {
      try{
         let data = await axios.delete(`${Baseurl}/banner?id=${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const promocode = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/promocode`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
         enqueueSnackbar(`${error.response?.data?.message}`,{variant: 'error'})
      }
    }

    const getPromocode = async () => {
      try{
         let data = await axios(`${Baseurl}/promocode`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const getcodeById = async (id) => {
      try{
         let data = await axios(`${Baseurl}/promocode/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const editCodeById = async (id,params) => {
      try{
         let data = await axios.patch(`${Baseurl}/promocode/${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

     const deleteCodeByID = async (id) => {
      try{
         let data = await axios.delete(`${Baseurl}/promocode/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const getDeals = async () => {
      try{
         let data = await axios(`${Baseurl}/deal?admin=true`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
    const createDeal = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/deal`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

   const deleteDeal = async () => {
      try{
         let data = await axios.delete(`${Baseurl}/deal`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const getCountry = async () => {
      try{
         let data = await axios(`${Baseurl}/country`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
    const createCountry = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/country`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
    const updateCountry = async (id,params) => {
      try{
         let data = await axios.patch(`${Baseurl}/country/${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
    const getCountryByid = async (id) => {
      try{
         let data = await axios(`${Baseurl}/country/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

     const deleteCountryByid = async (id) => {
      try{
         let data = await axios.delete(`${Baseurl}/country/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const getFooter = async () => {
      try{
         let data = await axios(`${Baseurl}/footer`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const createFooter = async (id,params) => {
      try{
         let data = await axios.patch(`${Baseurl}/footer?id=${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 
    const getProductByID = async (id) => {
      try{
         let data = await axios(`${Baseurl}/product/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
    const login = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/login?admin=adminauth`,params,{withCredentials:true})
         return data
      }catch(error){
         alert(error?.response?.data?.message)
         console.log(error);
      }
    } 

    const logout = async () => {
      try{
         let data = await axios(`${Baseurl}/logout`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
    const editProductapi = async (params,id) => {
      try{
         let data = await axios.patch(`${Baseurl}/products/${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }
  
    const orderCount = async () => {
      try{
         let data = await axios(`${Baseurl}/ordercount`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const UserCount = async () => {
      try{
         let data = await axios(`${Baseurl}/usercount`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

    const editUser = async (params,id) => {
      try{
         let data = await axios.patch(`${Baseurl}/getuser?id=${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const getUser = async (id) => {
      try{
         let data = await axios(`${Baseurl}/getuser?id=${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const getAllEmirates = async () => {
      try{
         let data = await axios(`${Baseurl}/emirate`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const createEmirate = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/emirate`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const editEmirate = async (params,id) => {
      try{
         let data = await axios.patch(`${Baseurl}/emirate?id=${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const deleteEmirate = async (id) => {
      try{
         let data = await axios.delete(`${Baseurl}/emirate?id=${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const getSingleEmirate = async (id) => {
      try{
         let data = await axios(`${Baseurl}/emirate/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

   const getAllBoys = async () => {
      try{
         let data = await axios(`${Baseurl}/deliveryboy`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

   const createBoy = async (params) => {
      try{
         let data = await axios.post(`${Baseurl}/deliveryboy`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const editBoy = async (params,id) => {
      try{
         let data = await axios.patch(`${Baseurl}/deliveryboy?id=${id}`,params,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const deleteBoy = async (id) => {
      try{
         let data = await axios.delete(`${Baseurl}/deliveryboy?id=${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const getSingleBoy = async (id) => {
      try{
         let data = await axios(`${Baseurl}/deliveryboy/${id}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }  

   const adminalert = async () => {
      try{
         let data = await axios(`${Baseurl}/adminalert`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const notificationsRead = async () => {
      try{
         let data = await axios(`${Baseurl}/notificationseen`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    } 

    const orderChart = async (param) => {
      try{
         console.log(param, 'param');
         
      const params = new URLSearchParams();
      if (param === 'monthly') { 
         params.append('monthly', 'true'); 
      }
      if (param === 'weekly') { 
         params.append('weekly', 'true'); 
      }
         let data = await axios(`${Baseurl}/orderchart?${params.toString()}`,{withCredentials:true})
         return data
      }catch(error){
         console.log(error);
      }
    }

export  {
    addProduct, getCategory, getBrand, getProduct, Baseurl, deleteProduct, createCategory, deleteCategory,
    addBrand, deleteBrand, getType, addType, deleteType, getOrders, getallusers, deleteUser, getBrandByID,
    updateBrandByID, getCategoryByID, updateCategoryData, getCategById, getAuthor, addAuthor, deleteAuthor,
    getAuthorByID, updateAuthorData, addBlog, getBlogs, updateOrderData, orderDetails, createbaner, getBaner,
    getSingleBaner, updateBaner, promocode, getPromocode, getDeals, createDeal, getCountry, createCountry,
    updateCountry, getCountryByid, getFooter, createFooter, getProductByID, login, logout, editProductapi, orderCount,
    UserCount, editUser, getUser, getAllEmirates, createEmirate, editEmirate, deleteEmirate, getSingleEmirate,
    dealProductList, getcodeById, editCodeById, deleteCodeByID, deleteDeal, deleteBaner, deleteCountryByid,
    getBlogById, editBlog, deleteBlog, getAllBoys, createBoy, editBoy, deleteBoy, getSingleBoy, adminalert, getBrandForProdEdit,
    orderChart, notificationsRead
}